import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosing3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M62.25,18a15.69,15.69,0,0,0-13.64,8,8.65,8.65,0,0,0-3.86-.92A8.82,8.82,0,0,0,36,34H78A15.87,15.87,0,0,0,62.25,18Z",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "10.63 10.82 14.16 4.36 17.7 10.82 24.16 14.36 17.7 17.89 14.16 24.36 10.63 17.89 4.16 14.36 10.63 10.82",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 40,
			y1: 44.04,
			x2: 40,
			y2: 56.04,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 68.28,
			y1: 55.76,
			x2: 59.8,
			y2: 64.24,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.72,
			y1: 55.76,
			x2: 20.2,
			y2: 64.24,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.92,78A20,20,0,0,1,59,77.78",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: 78.04,
			x2: 80,
			y2: 78.04,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		})
	]
});
export default SvgClosing3;
